<script>
import { ImagePreview } from 'vant';
export default ({
  props: [
    'images',
    'animTime'
  ],
  data() {
    return {
      show: false,
      previewIndex: 0,
    }
  },
  methods: {
    onPreview(index) {
      this.show = true
      this.previewIndex = index
    },
    onChange(index) {
      this.previewIndex = index
    },
    getImagelist(){
      var list = [];
      for (var i =0;i<this.images.length;i++){
        list.push(this.images[i].src);
      }
      return list;
    },
    h5ImageTouch(index) {
      ImagePreview({
        images: this.images[index].src,
        startPosition: index,
        closeable: true,
      });
    },
  }
})
</script>

<template>
  <div>
    <van-image-preview ref="preview" v-model="show" :images="getImagelist()" :start-position="previewIndex" :closeable="true" @change="onChange"/>
    <van-swipe :loop="true" :autoplay="animTime">
      <van-swipe-item v-for="(img, i) in images" :key="i">
        <div class="img-icon-layout">
          <img class="img-icon" :src="img.src" @click="onPreview(i)">
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>

</template>

<style scoped lang="scss">

.img-icon-layout{
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-icon {
  height: 20rem;
}
</style>
